var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import posthog from 'posthog-js';
var isInitialized = false;
/**
 * Initialize PostHog with the provided API key and host
 * @param key - PostHog API key (from app_settings)
 * @param host - PostHog host URL (defaults to US cloud)
 */
export var initPostHog = function (key, host) {
    if (host === void 0) { host = 'https://us.i.posthog.com'; }
    if (isInitialized || !key) {
        return;
    }
    posthog.init(key, {
        api_host: host,
        person_profiles: 'identified_only',
        capture_pageview: true,
        capture_pageleave: true,
        autocapture: true,
        session_recording: {
            recordCrossOriginIframes: false
        }
    });
    isInitialized = true;
};
/**
 * Identify a user in PostHog
 * @param userId - Unique user identifier
 * @param properties - User properties (name, email, etc.)
 */
export var identifyUser = function (userId, properties) {
    if (!isInitialized) {
        return;
    }
    posthog.identify(userId, properties);
};
/**
 * Set the group (account) for the current user
 * @param groupId - Account/group identifier
 * @param properties - Group properties
 */
export var setGroup = function (groupId, properties) {
    if (!isInitialized) {
        return;
    }
    posthog.group('account', groupId, properties);
};
/**
 * Track a custom event
 * @param eventName - Name of the event
 * @param properties - Optional event properties
 */
export var trackEvent = function (eventName, properties) {
    if (!isInitialized) {
        return;
    }
    posthog.capture(eventName, properties);
};
/**
 * Track a page view
 * @param url - Optional URL to track (defaults to current URL)
 */
export var trackPageView = function (url) {
    if (!isInitialized) {
        return;
    }
    posthog.capture('$pageview', url ? { $current_url: url } : undefined);
};
/**
 * Capture an exception/error for error tracking
 * @param error - The error object
 * @param context - Additional context about the error
 */
export var captureException = function (error, context) {
    if (!isInitialized) {
        return;
    }
    posthog.capture('$exception', __assign({ $exception_type: error.name, $exception_message: error.message, $exception_stack_trace_raw: error.stack }, context));
};
/**
 * Reset the current user (call on logout)
 */
export var resetUser = function () {
    if (!isInitialized) {
        return;
    }
    posthog.reset();
};
/**
 * Get the PostHog instance for advanced usage
 */
export var getPostHog = function () { return posthog; };
export default posthog;
